<template>
  <div class="autocomplete-shell" :class="{'no-results': !items.length, 'inactive': query.length < 3}">
    <v-autocomplete :min-len='3' :wait="120" :items="items" v-model="item" ref="search" :get-label="getLabel" :component-item='template'
                    @input="onInput" @update-items="updateItems" :auto-select-one-item="false" @item-selected="selectItem" :placeholder="placeholder">
    </v-autocomplete>
  </div>
</template>

<script>
  import ItemTemplate from './ItemTemplate.vue'
  import { mapGetters } from 'vuex'
  export default {
    props: ['values', 'placeholder', 'value'],
    data () {
      return {
        item: null,
        items: [],
        template: ItemTemplate,
        cachedItems: [],
        query: ''
      }
    },
    computed: {
      ...mapGetters(['itemError'])
    },
    methods: {
      rebuildCache () {
        this.cachedItems = (this.values || []).map(item => ({
          item,
          name: String(item.Name || '').toLowerCase()
        }))
      },
      getLabel (item) {
        if (item) {
          return item.Name || item
        }
        return ''
      },
      updateItems (text) {
        const search = String(text || '').toLowerCase().trim()
        this.query = search
        if (!search) {
          return
        }
        const result = []
        const maxResults = 8
        for (let i = 0; i < this.cachedItems.length; i++) {
          if (this.cachedItems[i].name.includes(search)) {
            result.push(this.cachedItems[i].item)
            if (result.length >= maxResults) break
          }
        }
        this.items = result
      },
      selectItem (item) {
        if (!item) return
        const value = item.Name || String(item)
        this.query = String(value || '').toLowerCase().trim()
        this.items = []
        this.$emit('input', value)
      },
      onInput (text) {
        if (text === null || text === undefined) return
        if (typeof text === 'string') {
          this.query = text.toLowerCase().trim()
          this.$emit('input', text)
          return
        }
        if (text && text.Name) {
          const value = text.Name
          this.query = String(value || '').toLowerCase().trim()
          this.$emit('input', value)
        }
      }
    },
    watch: {
      values: {
        immediate: true,
        handler () {
          this.rebuildCache()
        }
      },
      value: {
        immediate: true,
        handler(val) {
          if (!val) {
             this.item = null
          } else if (this.values) {
             this.item = this.values.find(v => v.Name === val) || val
          }
        }
      },
      itemError: function (e) {
        this.item = null
      }
    }
  }
</script>


<style scoped>
.autocomplete-shell.no-results /deep/ .v-autocomplete-list,
.autocomplete-shell.inactive /deep/ .v-autocomplete-list {
  display: none;
  border: 0;
  box-shadow: none;
}
</style>
